export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  try {
    const parsed = JSON.stringify(error);
    if (parsed && parsed !== '{}') {
      return parsed;
    }
  } catch {
    // ignore
  }

  return fallback;
};
